import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";

export const EsquemasSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);

  useEffect(() => {
    request
      .get("CotizacionVentas/DDLEsquemas")
      .then((result) => {
        // Agregar la opción de "Consolidado" con id 0
        const esquemasOptions = [
          { value: -999, label: "Consolidado" }, 
          ...result.map((esquema) => ({
            value: esquema.id,
            label: esquema.label,
          })),
        ];
        setState(esquemasOptions);
      })
      .catch((error) => {
        console.error("Error obteniendo esquemas:", error);
      });
  }, []);

  return (
    <select className="select-esquema" name={name} value={value} onChange={onChange}>
      {state.map((item) => (
        <option key={`esquema-${item.value}`} value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
  );
};
